import Vue from 'vue';
import Main from './Main';

const ToastConstructor = Vue.extend(Main);

let instance;

const Toast = function(options = {}) {
  instance = new ToastConstructor({
    data: options
  });
  document.body.appendChild(instance.$mount().$el);
};

export default Toast;
